import { createContext } from 'react'
import { Translation } from '../types'

export const TranslationContext = createContext<Translation>(null)
